exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card .card-header .card-header-right .card-option {\n  width: 190px;\n  transition: unset; }\n\n.card .card-header + .card-block-hid .card-block, .card .card-header + .card-block-hid .card-block-big, .card .card-header + .card-block-hid .card-block-small {\n  padding-top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/apostolos/Documents/globalrank/src/app/shared/card/card.component.scss
// module id = ../../../../../src/app/shared/card/card.component.scss
// module chunks = main